/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Content__error } from "components/content/content";
import { Form__question, Form__subradio } from "components/form/form";

/**
 * styled components
 */

const Questions = styled.div`
  background-color: ${t.color.white};
  box-shadow: 0px 3px 5px 0 rgba(0, 0, 0, 0.3);
  border-width: 0 1px;
  border-style: solid;
  border-color: ${t.color.greyAlto};

  ${t.mixins.sm(`
    background-color: transparent;
    box-shadow: none;
  `)}
`;

const Error = styled(Content__error)`
  left: 50%;
  transform: translate(-50%, -50px);
`;

/**
 * questions component is..
 */

const Form__questions = ({ style, questions, error }) => {
  const { c } = useContext(ContentContext);
  return (
    <Questions style={style}>
      {questions.map(question => {
        if (question.type !== "subradio") {
          return <Form__question key={question.id} question={question} />;
        } else {
          return <Form__subradio key={question.id} question={question} />;
        }
      })}
      {error && <Error content={c("home.form.missing")} />}
    </Questions>
  );
};

export default Form__questions;

Form__questions.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Form__questions.defaultProps = {
  style: {},
};

/*
    import Form__questions from 'components/form/questions/form__questions'
    <Form__questions />
  */
